if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event.data.variant;
    document.querySelectorAll('.variant-description[data-variant-id]').forEach(function (el) {
      var isSelected = !!variant && String(variant.id) === el.dataset.variantId;
      el.style.display = isSelected ? 'block' : 'none';
    });
  });
}
